import { IUser } from 'global.interfaces';

const isSignedIn = (user: IUser | null | Record<string, never>): user is IUser => {
  return !!user && !!Object.keys(user).length;
};

const isInRole = (user: IUser, role: string): boolean => {
  const roles = user.roles?.split(', ') || [];

  return roles.indexOf(role) !== -1;
};

export { isSignedIn, isInRole };
